/* src/app/report-builder/pages/report-builder-basic/report-builder-basic.component.scss */
.report-builder-picker {
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px 12px;
}
/*# sourceMappingURL=report-builder-basic.component.css.map */
